import { useMutation, MutationOptions } from 'react-query';
import { resetAffordaPortalApplication } from '../services/affordaPortalService';

export default function useResetAffordaPortalApplication({
  options,
}: {
  options: MutationOptions,
}) {
  return useMutation(resetAffordaPortalApplication, options);
}
